import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import {useState} from "react";
import LoginModal from "./LoginModal";
import NewSubmissionModal from "./NewSubmissionModal";


const FilingIntroModal = ({filingModalOpen, setFilingModalOpen, selectedRows}) => {
    const [newSubmissionDropdown, setNewSubmissionDropdown] = useState(false);
    const [newSubmissionModalOpen, setNewSubmissionModalOpen] = useState(false);
    const [submissionType, setSubmissionType] = useState("");
    const [validToken, setValidToken] = useState(false);

    const docketNumber = selectedRows[0]?.generated_form_matter?.host_file_number || selectedRows[0]?.host_file_number;

    const handleClose = () => {
        setFilingModalOpen(false);
    };

    const handleClick = (buttonType) => {
        setNewSubmissionModalOpen(true);
        setSubmissionType(buttonType);
    };

    return (
        <div>
            <Dialog open={filingModalOpen} onClose={handleClose} aria-labelledby="form-dialog-title">
                {validToken ? <>
                        <DialogTitle id="form-dialog-title">
                            <Typography align="center" sx={{fontWeight: "bold"}}>{`Docket Number: ${docketNumber}`}</Typography>
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>Please select one of the filing options:</DialogContentText>
                            <br/>
                            <Box display="flex" justifyContent="space-between">
                                <Box sx={{display: "flex", flexDirection: "column", marginRight: 2}}>
                                    <Button variant="contained" color="primary" onClick={() => setNewSubmissionDropdown(!newSubmissionDropdown)} sx={{mb: 1}}>
                                        New Submission
                                    </Button>
                                    {newSubmissionDropdown && <>
                                        <Button variant="outlined" color="primary" onClick={() => handleClick("provisional")} sx={{mb: 1}}>
                                            Provisional
                                        </Button>
                                        <Button variant="outlined" color="primary" onClick={() => handleClick("non-provisional")} sx={{mb: 1}}>
                                            Non-Provisional
                                        </Button>
                                        <Button variant="outlined" color="primary" onClick={() => handleClick("371")}>
                                            371 Filing
                                        </Button>
                                    </>}
                                </Box>
                                <Box sx={{display: "flex", flexDirection: "column"}}>
                                    <Button variant="contained" color="secondary" onClick={() => handleClick("existing-submission")} sx={{"&:hover": {backgroundColor: "secondary.main"}}}>
                                        Existing Submission
                                    </Button>
                                </Box>
                            </Box>
                        </DialogContent>
                    </> :
                    <>
                        <Dialog open={filingModalOpen} onClose={handleClose} aria-labelledby="form-dialog-title">
                            <LoginModal setValidToken={setValidToken}/>
                        </Dialog>
                    </>}
            </Dialog>
            {newSubmissionModalOpen && <NewSubmissionModal newSubmissionModalOpen={newSubmissionModalOpen} setNewSubmissionModalOpen={setNewSubmissionModalOpen} selectedRows={selectedRows} submissionType={submissionType}/>}
        </div>
    );
};

export default FilingIntroModal;